export var WelcomePageTestSubject;
(function (WelcomePageTestSubject) {
    WelcomePageTestSubject["WelcomePage"] = "welcome-page";
    WelcomePageTestSubject["ExitWelcomeFlow"] = "exit-welcome-flow";
    WelcomePageTestSubject["PlaygroundModal"] = "playground-modal";
    WelcomePageTestSubject["DataSentModal"] = "data-sent-modal";
    WelcomePageTestSubject["GoBackButton"] = "go-back-button";
    WelcomePageTestSubject["BarDataStatusIndicator"] = "bar-data-status-indicator";
    WelcomePageTestSubject["CompleteFlowButton"] = "complete-welcome-flow-button";
    WelcomePageTestSubject["ContinueFlowButton"] = "continue-welcome-flow-button";
    WelcomePageTestSubject["UserRole"] = "user-welcome-page-role";
    WelcomePageTestSubject["UserDesiredProduct"] = "welcome-page-product";
})(WelcomePageTestSubject || (WelcomePageTestSubject = {}));
export var WelcomePageUserRole;
(function (WelcomePageUserRole) {
    WelcomePageUserRole["DevOps"] = "DevOps Engineer";
    WelcomePageUserRole["Developer"] = "Software Developer";
    WelcomePageUserRole["Admin"] = "System Administrator";
    WelcomePageUserRole["Executive"] = "Executive";
    WelcomePageUserRole["TeamLead"] = "Team Lead";
    WelcomePageUserRole["MarketingSales"] = "Marketing/Sales";
    WelcomePageUserRole["Security"] = "Security Analyst/Engineer";
    WelcomePageUserRole["Other"] = "Other";
})(WelcomePageUserRole || (WelcomePageUserRole = {}));
export var WelcomePageDesiredProducts;
(function (WelcomePageDesiredProducts) {
    WelcomePageDesiredProducts["LogsAnalytics"] = "Logs Analytics";
    WelcomePageDesiredProducts["InfraMonitoring"] = "Infrastructure Monitoring";
    WelcomePageDesiredProducts["AppMonitoring"] = "Application Monitoring";
    WelcomePageDesiredProducts["Traces"] = "Traces";
    WelcomePageDesiredProducts["SIEM"] = "SIEM";
})(WelcomePageDesiredProducts || (WelcomePageDesiredProducts = {}));
//# sourceMappingURL=welcome-page.enum.js.map